import { Stack } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom";
import QRCode from "react-qr-code";


const Dummy = () => {
  return (
    <Stack p={10}>
      <QRCode value="F2/33346/629039/0/1715156445/1715155464" />
    </Stack>
  );
  
};

export default Dummy;
